var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"popup popup--visible"},[_c('div',{class:'popup__content popup__content--'+_vm.rezise},[_c('div',{staticClass:"d-flex justify-content-center"},[_c('div',{staticClass:"popup__loader"},[_vm._v(_vm._s(`${_vm.message || 'Cargando...'}`))]),_c('mdb-spinner',{attrs:{"big":"","multicolor":""}})],1),_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }